/* eslint-disable react/jsx-fragments */
const React = require('react');

const { useRef, useEffect, useState } = React;
const { Script } = require('nordic/script');
const { getTranslationsBySite } = require('@pages/V2/translations');

function AdvertisingAdn(props) {
  const { content, device, isFirstCharge, siteId } = props;
  const [adLoaded, setAdLoaded] = useState(false);
  const [isBannerEmpty, setIsBannerEmpty] = useState(false);
  const translations = getTranslationsBySite(siteId);
  const { title } = translations.advertising;
  const { originalType, webView } = device;

  const ref = useRef(null);

  const namespace = originalType === 'desktop' ? 'advertising-desktop' : 'advertising-mobile';

  const handleAdLoaded = () => setAdLoaded(true);
  const handleBannerEmpty = () => setIsBannerEmpty(true);

  useEffect(() => {
    const node = ref.current;

    if (node) {
      node.addEventListener('adn-banner-loaded', handleAdLoaded);
      node.addEventListener('adn-banner-empty', handleBannerEmpty);
    }

    if (webView) document.body.dispatchEvent(new CustomEvent('adn-reload'));

    return () => {
      if (node) {
        node.removeEventListener('adn-banner-loaded', handleAdLoaded);
        node.removeEventListener('adn-banner-empty', handleBannerEmpty);
      }
    };
  }, [content, isFirstCharge]);

  return (
    <div data-testid="adn-component" className={`${namespace} ${isBannerEmpty ? `${namespace}-hide-ads` : ''}`}>
      {originalType === 'desktop' && adLoaded && (
        <div className={`${namespace}__title-container`}>
          {title && <span className={`${namespace}__title`}>{title}</span>}
          {title && <div className={`${namespace}__line`} />}
        </div>
      )}
      <Script src="https://http2.mlstatic.com/frontend-assets/adn-frontend-library/adn-script.js" />
      <div data-component="adn" data-content={JSON.stringify(content)} ref={ref} />
    </div>
  );
}

module.exports = AdvertisingAdn;
